import { ConfiguratorType } from '../../baseBtl/catalog/products/interface/configurable';
import { ProductBase } from '../../baseBtl/catalog/products/product';
import { Convergence } from '../../checkout/cart/promotions/convergence.class';
import { Customer } from '../../checkout/cart/promotions/customer.class';
import { Porta } from '../../checkout/cart/promotions/porta.class';
import { Promotion } from '../../checkout/cart/promotions/promotion.class';
import { PromoContextService } from '../../context/child/promo-context.service';

export enum PriceTypes {
    Today,
    EvryMonth,
    Other,
}

export interface RulesRenew {
    planType?: string[];
}

export abstract class Product extends ProductBase {
    /**
     *
     * @protected
     * @returns
     * @memberof Product
     */
    public updatePromotion(): void {
        const promoContext: PromoContextService =
            this.context.contextService.get<PromoContextService>(PromoContextService);
        if (!promoContext || !promoContext.promotions) {
            return;
        }

        const promotions = Promotion.refactorJson(promoContext.promotions);
        this.promotion = Promotion.getRules(promotions, this);
        this.porta = Porta.getRules(Porta.refactorJson(promoContext.promotions, ConfiguratorType.PORTA), this);
        this.convergence = Customer.getRules(
            Convergence.refactorJson(promoContext.convergence, ConfiguratorType.CONVERGENCE),
            this,
        );
        this.customer = Customer.getRules(
            Promotion.refactorJson(promoContext.promotions, ConfiguratorType.CUSTOMER),
            this,
        );
        this.locales = Promotion.getRules(
            Convergence.refactorJson(promoContext.promotions, ConfiguratorType.LOCALES),
            this,
        );
    }

    /**
     *
     * @public
     * @returns
     * @memberof Product
     */
    public getTitle(): string {
        let title: string = this.name;
        const manufacturer: string = this.getData('manufacturer');
        if (manufacturer) {
            title = `${manufacturer} ${title}`;
        }
        return title;
    }
}
